import React, { useContext, useState } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { PlusOutlined ,SaveOutlined} from '@ant-design/icons';
import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { AuthContext } from './Auth/Auth';
import { Input, notification } from 'antd';
import { ParPagComponentRequest, updatePageComponent } from 'services/displayFramework';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';


export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?:any;
  Inspectstyle?: React.CSSProperties;
};

const SaveButton = ({ comcode,custom,Inspectstyle, ...otherProps }: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { isInspect } = useContext(AuthContext);
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const [newLabel, setNewLabel] = useState('');

  if (isHidden) {
    return null;
  }
  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };

  const props = {
    ...otherProps,
  children: isInspect ? (
      <Input
        defaultValue={label === '' ? comcode : label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '80%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode, newLabel);
            }}
          />
        }
      />
    ) : (
      label
    ),
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        htmlType='submit'
        {...props}
        icon={<PlusOutlined color="white"/>}
        type="primary"
        style={{ width: 100, height: 40, margin: 5 }}
      />
    );
  }
};
export default SaveButton;



